import { Component, Output, Input, OnInit, EventEmitter, effect, ChangeDetectorRef, Inject } from '@angular/core';
import { ForgetPasswordRequest } from '@core/models/DTOs/authentication.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { LoginRegisterWrapperComponent } from '../login-register-wrapper.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from "@shared/components/notification/notification.service";
import { switchMap } from 'rxjs';
import { WINDOW } from '../login-register.module';


@Component({
  selector: 'iho-new-pass',
  templateUrl: './new-pass.component.html',
  styleUrls: ['./new-pass.component.scss'],
})
export class NewPassComponent implements OnInit {
  userData: any;
  inputTouched = false;
  constructor(public AuthService: AuthService,
    public notif: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(WINDOW) private window: Window,
    public changeDetection:ChangeDetectorRef,
    public dialogRef: MatDialogRef<LoginRegisterWrapperComponent>
    ) {

      effect(() => {
        this.userData = this.AuthService.getUserData()

        if (this.userData()) {
          this.endLogin()
        }
      })

  }

endLogin(){
   this.dialogRef.close();
  this.notif.success('عملیات موفق', 'رمز عبور  با موفقیت تغییر کرد');
  this.notif.success('ورود کاربر', '   با موفقیت انجام شد');
  this.router.navigate([], { relativeTo: this.route, queryParams: {} });
  this.changeDetection.detectChanges();

}
  @Input() ModelVerify = {
    Id: '',
    VerifyCode: '',
    ActivationWay: 0
  };
  @Input() phoneNumber = '';
  @Output() status = new EventEmitter();

  showPass: boolean = false;
  showLoading: boolean = false;
  passUser: string = '';
  errValidPass: boolean = false;
  isSend: boolean = true;

  ngOnInit(): void {

  }

  validatePass() {
    this.inputTouched = true
    let patternPass = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+-])[A-Za-z\d@$!%*#?&+-]*.{6,}$/;
    if ( this.passUser.length >= 6 && patternPass.test(this.passUser)) {
      this.errValidPass = false;
    } else {
      this.errValidPass = true;
    }

  }



  setPassword() {
    let modelForgetPasswordRequest: ForgetPasswordRequest = {
      Id: this.ModelVerify.Id,
      VerifyCode: this.ModelVerify.VerifyCode,
      UserName: this.phoneNumber,
      Password: this.passUser,
      Token: ''
    }
    this.showLoading = true;
    this.AuthService.forgetPassword(modelForgetPasswordRequest).pipe(switchMap(value =>{
      return this.AuthService.loginUser(modelForgetPasswordRequest)
    })).subscribe((res: any) => {
      localStorage.setItem('AccessToken', res?.jwtToken);
      document.cookie = `ihoLoggedIn=1; path=/; max-age=${60 * 60 * 24 * 30}`;
      this.showLoading = false;
      this.AuthService.userProfile();
    })
  }


}
